<template>
    <div>

        <el-row  class="row-bg" >
            <el-col :span="7">
                <div class="grid-content1">
                    인증 많이한 나라 TOP 7
                    <bar-chart
                            ref="BarChart"
                            :chk_date_end_date="chk_date_end_date"
                            width="500"
                            height="200"
                    ></bar-chart>

                    <!--            <pie-chart :data="chartData" :options="chartOptions"-->
                    <!--                       width="400"-->
                    <!--                       height="250"-->
                    <!--            ></pie-chart>-->


                </div>
            </el-col>

            <el-col :span="15" style="margin-left: 50px;">
                <div class="grid-content1">
                    인증 실패 많은 나라 TOP 10
                    <line-chart
                            ref="lineChart"
                            :chk_date_end_date="chk_date_end_date"
                            width="500"
                            height="200"
                    ></line-chart>
                </div>
            </el-col>
        </el-row>


        <el-row  class="row-bg" >
            <el-col :span="23">
                <el-radio-group v-model="chk_date_end_date"    @change="handleCheckedChange">
                    <el-radio :label="1">최근 1개월</el-radio>
                    <el-radio :label="3">최근 3개월</el-radio>
                    <el-radio :label="6">최근 6개월</el-radio>
                    <el-radio :label="9">최근 9개월</el-radio>
                    <el-radio :label="12">최근 12개월</el-radio>
                    <el-radio :label="0">전체</el-radio>

                    <el-button
                        v-if="adminFlag"
                        :loading="loading"
                        type="primary"
                        @click="handleCheckedChange"
                    >Search</el-button>


                </el-radio-group>

            </el-col>
        </el-row>

        <el-row  class="row-bg" >
            <el-col :span="23">
                <div class="grid-content2">

                    <div>



                        <gmap-map :zoom="10" :center="center" style="width:100%; height: 698px;" >
                            <!--              <gmap-marker :key="index" v-for="(m, index) in locationMarkers"-->
                            <!--                           :position="m.position"-->
                            <!--                           :label= label[index]-->
                            <!--                           :icon="m.icon"-->
                            <!--                           :animation="m.ani"-->
                            <!--              ></gmap-marker>-->


                            <gmap-marker :key="index" v-for="(m, index) in locationMarkers"
                                         :position="m.position"
                                         :icon="m.icon"
                                         :animation="m.ani"
                                         :clickable="true"
                                         :draggable="false"
                            ></gmap-marker>

                        </gmap-map>
                    </div>

                </div>
            </el-col>
        </el-row>

    </div>
</template>


<style>

.grid-content1 {
    height: 215px;
    border-style:solid;
    border-top-width: thin;
    border-bottom-width: thin;
    border-left-width: thin;
    border-right-width: thin;
    border-color : #8c939d;
}

.grid-content2 {
    height: 580px;
    border-style:solid;
    border-top-width: thin;
    border-bottom-width: thin;
    border-left-width: thin;
    border-right-width: thin;
    border-color : #8c939d;
}
/*.row-bg {*/
/*  height: 400px;*/
/*  width:  1000px;*/
/*  !*border-style:solid;*!*/
/*  border-top-width: thin;*/
/*  border-bottom-width: thin;*/
/*  border-left-width: thin;*/
/*  border-right-width: thin;*/
/*  border-color : #8c939d;*/
/*}*/
</style>

<script>

import LineChart from '@/views/components/LineChart'
// import AddGoogleMap from '@/views/components/AddGoogleMap.vue'
import BarChart from '@/views/components/BarChart'
import Axios from "axios";

// import PieChart from '@/views/components/PieChart'
// import BubbleChart from '@/views/components/Bubblechart'

export default {
    name: 'VueChartJS',
    components: {
        LineChart,
        // AddGoogleMap,
        BarChart,
        // PieChart,
        // BubbleChart,
    },

    data() {
        return {

            center: { lat: 37.4915792, lng: 126.8788277},

            locationMarkers: [
                // { position: { lat: 37.4407168, lng: 126.81216} },
                // { position: { lat: 37.4404168, lng: 126.81216 } },
                // { position: { lat: 37.5642135, lng: 127.0016985 } },
                // { position: { lat: 37.4915792, lng: 126.8788277 } },
            ],

            locPlaces: [],
            label : [],
            existingPlace: null,

            chk_date_end_date: 1,

            adminFlag:false,
        };
    },
    mounted() {
        this.geolocate();
    },
    created() {

        if (this.$store.state.accessToken != '100') {
            this.search();
            this.adminFlag=false;
        }else {
            this.adminFlag=true;
        }


    },
    methods: {

        async search() {
            this.loading = true;
            // default data
            let url = this.$url + '/authInfo/getLatLngGroup';
            var reqJson = new Object();

            if (this.$store.state.accessToken != '100')
                reqJson.rfid_get_order_seq = this.$store.state.rfid_get_order_seq;
            // reqJson.limit = 100;

            if (this.chk_date_end_date != '0')
                reqJson.chk_date_end_date = this.chk_date_end_date;

            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authInfoDTO;

                console.log(resDataJson);

                var tmpPosition = []
                var icon = []
                var ani = []
                this.locationMarkers = []
                for(var resData in resDataJson){
                    tmpPosition.push ({
                        lat :  Number ( resDataJson[resData]['latitude'] ) ,
                        lng :  Number ( resDataJson[resData]['longitude'] ),

                    });

                    if (resDataJson[resData]['success_fail'] =='F') {
                        icon.push({
                            url: 'http://maps.google.com/mapfiles/ms/icons/red.png',
                            // url: 'https://makesolutions.kr/uploads/red.jpg',
                        });
                        ani.push(1)
                    }
                    else {
                        icon.push({
                            url: 'http://maps.google.com/mapfiles/ms/icons/green.png',
                            // url: 'https://makesolutions.kr/uploads/green.jpg',
                            // // scaledSize: { width: 20, height: 20 },
                        });
                        ani.push(0)
                    }

                    this.locationMarkers.push ({
                        position : tmpPosition[resData],
                        icon: icon[resData],
                        ani:ani[resData],
                    })
                }

                this.loading = false;
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.currentPage = 1;
                    this.loading = false;
                }); // await Axios.post
        },//chkQrCode


        handleCheckedChange(){
            if (this.chk_date_end_date=="0")
                this.$message.success("젠체 데이터 조회 중입니다.");
            else
                this.$message.success("최근" + this.chk_date_end_date + "개월 데이터 조회 중입니다.");

            this.search();
        },

        geolocate: function () {
            navigator.geolocation.getCurrentPosition(position => {

                // console.log ( position.coords.latitude  );
                // console.log ( position.coords.longitude  );

                this.center = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude,
                };
            });
        },
    },

}
</script>
<style>
#app { font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #000000;
    margin-top: 0px;
}

</style>
